import * as ImagePicker from 'expo-image-picker';
import React, {useCallback, useEffect} from 'react';
import {Actionsheet} from 'native-base';
import {Platform} from 'react-native';
import {useTranslation} from 'react-i18next';

interface SelectImageComponentProps {
    isOpen: boolean;
    onClose: () => void;
    setResult: (result: ImagePicker.ImagePickerAsset) => void;
    mediaTypes?: ImagePicker.MediaTypeOptions;
}

const SelectMediaModal = (props: SelectImageComponentProps) => {
    const {setResult, isOpen, onClose, mediaTypes = ImagePicker.MediaTypeOptions.Images} = props;
    const {t} = useTranslation();
    const [status, requestPermission] = ImagePicker.useCameraPermissions();

    const launchCamera = useCallback(async(mediaTypes: ImagePicker.MediaTypeOptions) => {
        const launch = async() => {
            const result = await ImagePicker.launchCameraAsync({
                mediaTypes,
                allowsEditing: true,
                quality: 1,
                base64: true,
            });
            if (!result.canceled) {
                setResult(result.assets[0]);
                onClose();
            }
        };

        if(status?.granted === true){
            launch();
        } else {
            const permission = await requestPermission();
            if(permission.granted) {
                launch();
            }
        }
    }, [status]);

    const pickAsset = useCallback(async() => {
        const result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes,
            allowsEditing: true,
            quality: 1,
            base64: true,
        });

        if (!result.canceled) {
            setResult(result.assets[0]);
            onClose();
        }
    }, []);

    useEffect(() => {
        if(isOpen && Platform.OS === 'web'){
            pickAsset();
            onClose();
        }
    }, [isOpen]);

    if(Platform.OS === 'web') {
        return (
            <></>
        );
    }

    return (
        <Actionsheet
            isOpen={isOpen}
            onClose={onClose}
        >
            <Actionsheet.Content>
                <Actionsheet.Item onPress={() => launchCamera(mediaTypes)}>{t('media.takePicture')}</Actionsheet.Item>

                <Actionsheet.Item onPress={pickAsset}>{t('media.openLibrary')}</Actionsheet.Item>
            </Actionsheet.Content>
        </Actionsheet>
    );
};

export default SelectMediaModal;
